/*
 * Copyright (c) Nexign, JSC, 2022.
 */
/**
 *
 * @author Evgeniy Naumov
 * @author Ilya Babanov
 * @version 1.22.0
 * @since 1.22.0
 */

import { icons } from '@theme/index';

import type { IConstructorReport, INewReportsData } from './types';

export enum EReportsConstructorSource {
    WIDGET = 'WIDGET',
    ACCOUNT = 'ACCOUNT',
    ACCOUNT_LIST = 'ACCOUNT_LIST',
    MOBILE_LIST = 'MOBILE_LIST',
    AUTO_REPORTS = 'AUTO_REPORTS',
}

export enum EConstructorReportsNew {
    REPORT_CUSTOM_SUBSCRIBERS = 'REPORT_CUSTOM_SUBSCRIBERS',
    REPORT_CUSTOM_TARIFFS = 'REPORT_CUSTOM_TARIFFS',
    REPORT_CUSTOM_CORP_CLIENTS = 'REPORT_CUSTOM_CORP_CLIENTS',
}

export enum EConstructorReportsAdditional {
    REPORT_SUBSCRIBERS_WITH_LIMITS = 'REPORT_SUBSCRIBERS_WITH_LIMITS',
    REPORT_SUBSCRIBERS_WITH_MIN_LIMITS = 'REPORT_SUBSCRIBERS_WITH_MIN_LIMITS',
    REPORT_SUBSCRIBERS_WITH_PARAMETERS = 'REPORT_SUBSCRIBERS_WITH_PARAMETERS',
    REPORT_SUBSCRIBERS_WITH_BLOCK = 'REPORT_SUBSCRIBERS_WITH_BLOCK',
    REPORT_SUBSCRIBERS_NEW = 'REPORT_SUBSCRIBERS_NEW',
    REPORT_SUBSCRIBERS_WITH_STATIC_IP = 'REPORT_SUBSCRIBERS_WITH_STATIC_IP',
}

export type TConstructorReportTypes = EConstructorReportsNew | EConstructorReportsAdditional;

export const CONSTRUCTOR_REPORT_TYPES = {
    ...EConstructorReportsNew,
    ...EConstructorReportsAdditional,
};

export const NEW_REPORTS_DATA: Array<Omit<INewReportsData, 'title' | 'description'>> = [
    {
        id: 21,
        type: CONSTRUCTOR_REPORT_TYPES.REPORT_CUSTOM_SUBSCRIBERS,
        icon: icons.reportsSubs,
    },
    {
        id: 22,
        type: CONSTRUCTOR_REPORT_TYPES.REPORT_CUSTOM_TARIFFS,
        icon: icons.reportsBag,
    },
    {
        id: 23,
        type: CONSTRUCTOR_REPORT_TYPES.REPORT_CUSTOM_CORP_CLIENTS,
        icon: icons.reportsRub,
    },
];

export const ADDITIONAL_REPORTS_ICONS: {
    [Property in keyof typeof EConstructorReportsAdditional]: Pick<IConstructorReport, 'icon'>;
} = {
    REPORT_SUBSCRIBERS_WITH_LIMITS: {
        icon: icons.reportsInf,
    },
    REPORT_SUBSCRIBERS_WITH_MIN_LIMITS: {
        icon: icons.reportsInf,
    },
    REPORT_SUBSCRIBERS_WITH_PARAMETERS: {
        icon: icons.reportsSubs,
    },
    REPORT_SUBSCRIBERS_WITH_BLOCK: {
        icon: icons.reportsLock,
    },
    REPORT_SUBSCRIBERS_NEW: {
        icon: icons.reportsPhones,
    },
    REPORT_SUBSCRIBERS_WITH_STATIC_IP: {
        icon: icons.reportsSim,
    },
};

export enum ETemplateRenameField {
    name = 'name',
}

export enum EMode {
    SAVE = 'save',
    EDIT = 'edit',
}

export enum EConstructorItem {
    REPORT = 'report',
    TEMPLATE = 'template',
}

export const TEMPLATES_LOAD_SIZE = 6;
